import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

export const fetchEnquiryList = async ({ userId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/enquiry/getall`, {
    params: { UserId: userId, IsForDropodown: '0' }
  });
  const rows = response?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchEnquiryById = async ({ userId, enquiryId }) => {
  const response = await axios.get(`${getApiBaseUrl()}/enquiry/getbyid`, {
    params: { UserId: userId, EnquiryId: enquiryId }
  });
  return response?.data?.data ?? { header: null, details: [] };
};

export const saveEnquiry = async ({ enquiryId, customerName, mobileNo, enquirySource, referenceName, area, vehicleEnquiries, userId }) => {
  const payload = {
    EnquiryId: enquiryId ?? null,
    CustomerName: customerName ?? '',
    MobileNo: mobileNo ?? '',
    EnquirySource: enquirySource ?? null,
    ReferenceName: referenceName ?? null,
    Area: area ?? null,
    VehicleEnquiries: vehicleEnquiries ?? [],
    UserId: userId
  };
  const response = await axios.post(`${getApiBaseUrl()}/enquiry/save`, payload);
  return response?.data;
};

export const deleteEnquiry = async ({ enquiryId, userId }) => {
  const response = await axios.post(`${getApiBaseUrl()}/enquiry/delete`, {
    EnquiryId: enquiryId,
    UserId: userId
  });
  return response?.data;
};
